import { useMemo, useState } from "react";
import { getStorageArea } from "./storageArea";

export function useStorageBackedState<T>(
  key: string,
  defaultValue: T,
  storage: "session" | "local" | "memory" = "local"
): [T, (newValue: T) => void] {
  const storageArea = useMemo(() => getStorageArea(storage), [storage]);

  const [value, _setValue] = useState<T>(() => {
    const storedValue = storageArea.getItem(key);
    if (storedValue === null) {
      return defaultValue;
    }
    return JSON.parse(storedValue);
  });

  const setValue = (newValue: T) => {
    _setValue(newValue);
    storageArea.setItem(key, JSON.stringify(newValue));
  };

  return [value, setValue];
}
